module.exports = __webpack_public_path__ + "static/img/theme_05.25a334d0.png";